import React, { memo } from 'react';
import { ShieldCheck, Mail, Star } from 'lucide-react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="pt-12 pb-10 px-6 bg-sage-800" data-id="element-90">
      <div className="max-w-4xl mx-auto text-center" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-92">
          <span className="inline-block py-1 px-4 rounded-full bg-sage-700 text-sage-100 font-medium text-sm sm:text-base mb-6 border border-sage-600" data-id="element-93">
            Para Adultos Mayores que quieren mantener su mente activa
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-94">
            El cuadernillo que te ayuda a mantener tu mente ágil todos los días
          </h1>

          <img src="https://cdn.magicpatterns.com/uploads/pAecCtUYjjUhY37KFHorio/pasted-image.png" alt="Kit Mente Clara & Activa — Incluye cuadernillo principal, 300 Sudokus, Sopa de Letras y más" className="mx-auto mb-8 w-full max-w-md md:max-w-lg rounded-xl" data-id="element-95" />

          <p className="text-xl text-sage-100 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-96">
            Más de 150 ejercicios claros y fáciles de hacer en tu casa, pensados
            para adultos mayores. Sin palabras complicadas. Sin ejercicios
            infantiles. Listos para empezar hoy mismo.
          </p>

          <div className="flex flex-col items-center gap-4 mb-10 text-left max-w-md mx-auto" data-id="element-97">
            <div className="flex items-center gap-3 w-full bg-sage-900/50 p-3 rounded-lg border border-sage-600/40" data-id="element-98">
              <div className="bg-sage-600 p-1 rounded-full text-white shrink-0" data-id="element-99">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-100">
                  <polyline points="20 6 9 17 4 12" data-id="element-101"></polyline>
                </svg>
              </div>
              <span className="font-medium text-sage-50" data-id="element-102">
                Adultos de 50 años en adelante
              </span>
            </div>
            <div className="flex items-center gap-3 w-full bg-sage-900/50 p-3 rounded-lg border border-sage-600/40" data-id="element-103">
              <div className="bg-sage-600 p-1 rounded-full text-white shrink-0" data-id="element-104">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-105">
                  <polyline points="20 6 9 17 4 12" data-id="element-106"></polyline>
                </svg>
              </div>
              <span className="font-medium text-sage-50" data-id="element-107">
                Quienes quieren cuidar su memoria
              </span>
            </div>
            <div className="flex items-center gap-3 w-full bg-sage-900/50 p-3 rounded-lg border border-sage-600/40" data-id="element-108">
              <div className="bg-sage-600 p-1 rounded-full text-white shrink-0" data-id="element-109">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-110">
                  <polyline points="20 6 9 17 4 12" data-id="element-111"></polyline>
                </svg>
              </div>
              <span className="font-medium text-sage-50" data-id="element-112">
                Quienes buscan mantenerse mentalmente activos
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2 mb-8" data-id="element-113">
            <div className="flex text-[#e8a365]" data-id="element-114">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} size={24} fill="currentColor" data-id="element-115" />)}
            </div>
            <p className="text-sage-200 font-medium" data-id="element-116">
              4.9/5 · Más de 200 adultos mayores ya lo usan
            </p>
          </div>

          <Button href="#pricing" variant="secondary" className="text-xl px-10 py-5 mb-6 w-full sm:w-auto" data-id="element-117">
            ¡QUIERO MI KIT AHORA!
          </Button>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-sage-300" data-id="element-118">
            <span className="flex items-center gap-2" data-id="element-119">
              <ShieldCheck size={18} className="text-sage-400" data-id="element-120" />
              Compra 100% segura
            </span>
            <span className="hidden sm:inline text-sage-600" data-id="element-121">|</span>
            <span className="flex items-center gap-2" data-id="element-122">
              <Mail size={18} className="text-sage-400" data-id="element-123" />
              Acceso inmediato por mail
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}